<template>
  <div>
    <b-overlay
      :show="loading"
      blur="2px"
      bg-color="dark"
    >
      <b-card no-body>
        <b-card-header>
          <h3>Teknik Özellikler</h3>
          <div class="text-right">
            <b-button
              variant="primary"
              @click="addRow"
            >
              <feather-icon icon="PlusIcon" />
              Ekle
            </b-button>
          </div>
        </b-card-header>
        <b-card-body>
          <b-alert
            show
            variant="warning"
          >
            <div class="alert-body text-center">
              Değişikliklerinizi kaydetmeden sıra no güncellemesi yapmayın; aksi halde veri kaybı yaşanabilir.
            </div>
          </b-alert>
          <template v-if="dataList.length > 0">
            <b-row
              v-for="(item, index) in dataList"
              :key="index"
              class="d-flex justify-content-center align-items-center"
            >
              <b-col
                cols="12"
                md="2"
                lg="1"
                style="min-width: 100px !important;"
              >
                <order-number
                  :i-key="index"
                  :save-data="orderingUpdate"
                />
              </b-col>
              <b-col>
                <product-items-title-card :i-key="index" />
              </b-col>
              <b-col>
                <product-items-value-card :i-key="index" />
              </b-col>
              <b-col>
                <color-select :i-key="index" />
              </b-col>
              <b-col md="auto">
                <b-button
                  variant="flat-danger"
                  class="btn-icon rounded-circle"
                  @click="removeData(item.id, index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-alert show>
              <div class="alert-body mt-1 text-center">
                <feather-icon icon="InfoIcon" />
                Teknik Özellik Eklenmemiş.
              </div>
            </b-alert>
          </template>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol, BButton, BCard, BCardHeader, BAlert, BCardBody, BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProductItemsTitleCard from '@/views/Admin/Products/Elements/Items/TitleCard.vue'
import ProductItemsValueCard from '@/views/Admin/Products/Elements/Items/ValueCard.vue'
import ColorSelect from '@/views/Admin/Products/Elements/Items/ColorSelect.vue'
import OrderNumber from '@/views/Admin/Products/Elements/Items/OrderNumber.vue'

export default {
  name: 'ProductItemsForm',
  components: {
    BAlert,
    ProductItemsValueCard,
    ProductItemsTitleCard,
    ColorSelect,
    OrderNumber,
    BRow,
    BCol,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
    dataList() {
      return this.$store.getters['productItems/dataList']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getColors()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productItems/getDataList', {
        where: {
          'product_items.id_products': this.$route.params.id,
        },
      })
    },
    getColors() {
      this.$store.dispatch('tableColors/getDataList')
    },
    orderingUpdate(index) {
      this.loading = true
      this.$store.dispatch('productItems/orderingUpdate', {
        id: this.dataList[index].id,
        ordering: this.dataList[index].ordering,
        id_products: this.dataList[index].id_products,
      })
        .then(response => {
          if (response) {
            this.getDataList()
            this.loading = false
          }
        })
    },
    removeData(id, index) {
      if (id) {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('productItems/removeData', id)
              .then(response => {
                if (response) {
                  this.getDataList()
                  // this.dataList.splice(index, 1)
                  this.$swal({
                    icon: 'success',
                    title: this.$store.state.app.removeResultTitle,
                    text: this.$store.state.app.removeResultMessage,
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
          }
        })
      } else {
        this.dataList.splice(index, 1)
      }
    },
    addRow() {
      this.dataList.push({
        id: null,
        title: null,
        value: null,
        ordering: this.dataList.length > 0 ? this.dataList.length + 1 : 1,
        id_table_colors: null,
        id_products: this.itemData.id,
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
